import { IconButton, Typography } from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'

import { useStyles } from './styles'

type HeaderProps = {
  title: string
  goBack: () => void
}

export const Header = ({ title, goBack }: HeaderProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <IconButton aria-label='Voltar' color='secondary' onClick={goBack}>
        <ArrowBack />
      </IconButton>
      <Typography variant='h3'>{title}</Typography>
    </div>
  )
}
